<template>
	<div class="status">
		<div
			:class="`state--${state}`"
			class="state"
		>
			<div />
			<div />
			<div />
		</div>

		{{ text }}
	</div>
</template>

<script>
export default {
	name: 'Status',

	props: {
		state: {
			type: String,
			required: false,
			validator: value => [
				'neutral',
				'success',
				'alert',
				'danger',
				'info',
			].indexOf(value) !== -1,
			default: 'neutral',
			description: 'Sets the state (and therefore the colour) of the Status indicator',
		},

		text: {
			type: String,
			required: true,
			description: 'Sets the label that will appear next to the Status indicator',
		},
	},
};
</script>

<style lang="scss" src="./status.scss" />
